import { combineReducers } from '@reduxjs/toolkit';

import Notifications from '@frontend/common/build/components/Notifications/reducer';
import Params from 'components/AppRoot/Navigation/reducer';

const rootReducer = combineReducers({
  notifications: Notifications,
  params: Params,
});

export default rootReducer;